export const DATA_TRACKING_SUBMENU = 'data-tracking-submenu';
export const DATA_TRACKING_SECTION = 'data-tracking-section';
export const DATA_TRACKING_PLACEMENT = 'data-tracking-placement';
export const DATA_TRACKING_CLICK_DISABLED = 'data-tracking-click-disabled';
export const getTrackingAttributes = ({
  submenu,
  section,
  placement,
  clickDisabled,
}: {
  submenu?: string;
  section?: string;
  placement?: string;
  clickDisabled?: 'true' | 'false';
}) => {
  return {
    [DATA_TRACKING_SUBMENU]: submenu,
    [DATA_TRACKING_SECTION]: section,
    [DATA_TRACKING_PLACEMENT]: placement,
    [DATA_TRACKING_CLICK_DISABLED]: clickDisabled,
  };
};
